import "./partials/bootstrap";

import Notifications, {notify} from '@kyvg/vue3-notification';

import {createApp, defineAsyncComponent} from 'vue';
import {createPinia} from 'pinia';

import Formcontrol from "../vue/form/formcontrol";
import Comments from "../vue/post/Comments";
import Rate from "../vue/partials/rate";
import Rating from "../vue/partials/rating";
import UserCover from "../vue/user/UserCover";
import Ava from "../vue/partials/ava";
import smartdate from "../vue/partials/smartdate";
import Timeline from "../vue/partials/Timeline";
import Comment from "../vue/post/Comment";
import PostOptions from "../vue/post/PostOptions";
import InfinityScroll from "../vue/partials/InfinityScroll";
import UserNotifications from "../vue/user/UserNotifications";
import vClickOutside from "click-outside-vue3"
import theme from "../vue/partials/theme";
import {Fancybox} from "@fancyapps/ui";
import ResizeFrames from "./partials/ResizeFrames";
import TwitterHeight from "./directives/TwitterHeight";
import YoutubeClick from "./modules/YoutubeClick";
import SubscribeButton from "./../vue/partials/SubscribeButton";
import BlockUser from "./../vue/partials/BlockUser";
import FavoriteToggle from "../vue/user/FavoriteToggle.vue";
import UserItem from "../vue/user/UserItem";
import ChannelItem from "../vue/partials/ChannelItem";
import ChannelMenu from "../vue/partials/ChannelMenu.vue";
import Poll from "../vue/partials/Poll";
import PostBody from "../vue/post/PostBody";
import BlockChannel from "../vue/partials/BlockChannel";
import PostItem from "../vue/post/PostItem";
import UserMenu from "../vue/user/UserMenu";
import UserProfile from "../vue/user/UserProfile.vue";
import UserSettings from "../vue/user/UserSettings";
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import Oleg from "../vue/partials/oleg";
import PostView from "../vue/post/PostView";
import FloatingVue from 'floating-vue';
import ModerStat from "../vue/partials/ModerStat";
import Search from "../vue/partials/Search.vue";
import SearchResults from "../vue/partials/SearchResults.vue";
import {UserStore} from "./stores/UserStore";
import Client from "./modules/Client";
import Theme from "./modules/Theme";
import SvgIcon from "../vue/partials/SvgIcon.vue";
import Avatar from "../vue/partials/Avatar.vue";
import {MainStore} from "./stores/MainStore";

import Tracker from "./tracker";

import UserLink from "../vue/user/UserLink.vue";
import UserValentines from "../vue/user/UserValentines.vue";
import MainRating from "../vue/components/MainRating.vue";
import ChannelList from "../vue/partials/ChannelList.vue";
import Snowfall from "../vue/partials/Snowfall.vue";

let PostForm = defineAsyncComponent(() => import('../vue/post/PostForm'));

if (location.hash) {
    setTimeout(function () {
        window.scrollTo(1, 0);
    }, 1.2);
}

let currentUrl = window.location.pathname;
let prevUrl = localStorage.getItem('currentUrl');
localStorage.setItem('currentUrl', currentUrl);
localStorage.setItem('previousUrl', prevUrl || '/');

Tracker.track('Page view');

const pinia = createPinia();

const app = createApp({
    setup() {
        const store = UserStore();
        Client.get('/api/v1.1/user/data').then(response => {
            let userData = response.data.data;
            store.setUser(userData);

            if (userData.id) {
                Tracker.identify(userData.id);
            }
        });
    },
    data() {
        return {
            menuOpened: true,
            store: MainStore()
        }
    },
    computed: {
        timelineIcon() {
            let visible = this.store.isTimelineVisible;

            if (visible) {
                return 'chevron-left';
            }

            return 'chevron-right';
        }
    },
    methods: {
        toggleTimeline() {
            this.store.toggleTimeline();
        },
        toggleMenu() {
            this.$refs.menu.classList.toggle('hidden');
        },
        checkMenuVisibility(e) {
            let el = e.target;
            if (el.classList.contains('menu-toggle') || el.closest('.menu-toggle')) {
                return;
            }
            if (window.screen.width < 1024 && !this.$refs.menu.classList.contains('hidden')) {
                this.$refs.menu.classList.add('hidden');
            }
        }
    },
    mounted() {
        Fancybox.defaults.Hash = false;
        Fancybox.bind("[data-fancybox]", {
            compact: false,
            backdropClick: 'close',
            contentClick: 'toggleZoom',
            dragToClose: true,
            Images: {
                initialSize: "fit",
            },
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: ["zoomIn", "zoomOut"],
                    right: ["download", "close"],
                },
            },
        });

        let resetScroll = document.querySelectorAll('.data-reset-scroll');
        if (resetScroll) {
            resetScroll.forEach(el => {
                el.addEventListener('click', () => {
                    localStorage.removeItem('scroll-item');
                })
            });
        }

        new Theme();

        YoutubeClick();
        ResizeFrames.listen();
    },
});

app.directive('twitter-height', TwitterHeight);

app.directive('autogrow', {

    mounted(el, binding) {
        el.setAttribute("style", "height:" + el.scrollHeight + "px;");
        el.addEventListener("input", OnInput, false);
        el.addEventListener("paste", OnInput, false);

        function OnInput(event) {
            let maxHeight = binding.value || 150;
            let minHeight = 40;
            el.style.height = 'auto';
            let height = el.scrollHeight;
            if (height > maxHeight) {
                height = maxHeight;
            }
            if (height < minHeight) {
                height = minHeight;
            }
            el.style.height = height + "px";
            el.style.maxHeight = height + "px";
        }

        setTimeout(() => {
            OnInput();
        }, 110);
    }

})

app.component('search', Search);
app.component('search-results', SearchResults);
app.component('user-menu', UserMenu);
app.component('user-link', UserLink);
app.component('post-view', PostView);
app.component('post-form', PostForm);
app.component('Poll', Poll);
app.component('post-item', PostItem);
app.component('post-body', PostBody);
app.component('channel-menu', ChannelMenu);
app.component('channel-list', ChannelList);
app.component('channel-item', ChannelItem);
app.component('block-user', BlockUser);
app.component('block-channel', BlockChannel);
app.component('subscribe-button', SubscribeButton);
app.component('infinity-scroll', InfinityScroll);
app.component('smartdate', smartdate);
app.component('post-options', PostOptions);
app.component('formcontrol', Formcontrol);
app.component('comments', Comments);
app.component('rate', Rate);
app.component('rating', Rating);
app.component('ava', Ava);
app.component('timeline', Timeline);
app.component('comment', Comment);
app.component('user-item', UserItem);
app.component('favorite-toggle', FavoriteToggle);
app.component('user-settings', UserSettings);
app.component('user-valentines', UserValentines);
app.component('user-profile', UserProfile);
app.component('user-notifications', UserNotifications);
app.component('UserCover', UserCover);
app.component('theme', theme);
app.component('oleg', Oleg);
app.component('moder-stat', ModerStat);
app.component('svg-icon', SvgIcon);
app.component('avatar', Avatar);
app.component('main-rating', MainRating);
app.component('snowfall', Snowfall);

app.use(pinia);
app.use(vClickOutside);
app.use(Notifications);
app.use(PerfectScrollbar);
app.use(FloatingVue);

app.mount('#app');

if (window.notifications) {
    if (window.notifications.success) {
        notify({
            type: 'success',
            text: window.notifications.success,
        });
    }
    if (window.notifications.error) {
        notify({
            type: 'error',
            text: window.notifications.error,
        });
    }
}
